// TelcoTrack — portals a list's pill group into the active app-page-header
// title row (`.tt-page-header__pills`), centered between the title and actions.
// Hub children (Katalog, Kategorie) keep the pills in their own template; this
// service moves that node onto the shared title-row slot.

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PageHeaderPillsService {
  private readonly slots: HTMLElement[] = [];
  private source: HTMLElement | null = null;
  private placeholder: Comment | null = null;

  private get slot(): HTMLElement | null {
    return this.slots[this.slots.length - 1] ?? null;
  }

  registerSlot(slot: HTMLElement): void {
    const existing = this.slots.indexOf(slot);
    if (existing >= 0) this.slots.splice(existing, 1);
    this.restore();
    this.slots.push(slot);
    this.tryMove();
  }

  unregisterSlot(slot: HTMLElement): void {
    const idx = this.slots.indexOf(slot);
    if (idx < 0) return;
    const wasActive = idx === this.slots.length - 1;
    if (wasActive) this.restore();
    this.slots.splice(idx, 1);
    if (wasActive) this.tryMove();
  }

  attach(source: HTMLElement): void {
    if (this.source && this.source !== source) {
      this.restore();
    }
    this.source = source;
    this.tryMove();
  }

  detach(source: HTMLElement): void {
    if (this.source !== source) return;
    this.restore();
    this.source = null;
  }

  private tryMove(): void {
    if (!this.slot || !this.source) return;
    if (this.source.parentElement === this.slot) return;
    this.placeholder = document.createComment('tt-page-header-pills');
    this.source.parentNode?.insertBefore(this.placeholder, this.source);
    this.slot.appendChild(this.source);
  }

  private restore(): void {
    if (!this.source || !this.placeholder?.parentNode) {
      this.placeholder = null;
      return;
    }
    this.placeholder.parentNode.insertBefore(this.source, this.placeholder);
    this.placeholder.remove();
    this.placeholder = null;
  }
}
